<div class="container-fluid">

    <div class="row align-items-center">

        <div class="col-lg-6 col-md-4 d-lg-block d-md-block d-sm-none d-none">
            <img src="assets/images/security_related_signUp_image.jpg" class="img-fluid" alt="image">
        </div>

        <div class="col-lg-6 col-md-8 m-auto">

            <div class="card mt-xl-4 mt-lg-5 mt-md-5 mt-sm-5 mt-0">

                <div class="card-header">

                    <div class="card-header-label">
                        <span> Sign Up </span>
                    </div>

                    <div class="card-header-link">
                        <span> Already Have an Account ? <a class="registerHere" (click)="click_showLoginModal()"> Login
                                In </a>
                        </span>
                    </div>

                </div>

                <div class="card-body px-lg-5 px-md-4 px-sm-4 px-3">
                    <div class="form-outline mb-4">
                        <label class="form-label"> First Name </label>
                        <input type="text" [(ngModel)]="viewModel.userDetails.firstName" class="form-control"
                            placeholder="Enter first Name " />
                        <!-- <div class="error-message" *ngIf="viewModel.hasValidationError('firstName')">
                            {{viewModel.getValidationMessage("firstName") }}
                        </div> -->
                    </div>


                    <div class="form-outline mb-4">
                        <label class="form-label"> Last Name </label>
                        <input type="text" [(ngModel)]="viewModel.userDetails.lastName" class="form-control"
                            placeholder="Enter Last Name " />
                        <!-- <div class="error-message" *ngIf="viewModel.hasValidationError('lastName')">
                            {{viewModel.getValidationMessage("lastName")}}
                        </div> -->
                    </div>

                    <div class="form-outline mb-4">
                        <label class="form-label"> Email Address </label>
                        <input type="email" [(ngModel)]="viewModel.userDetails.email" class="form-control"
                            placeholder="Enter a valid email address" />
                        <!-- <div class="error-message" *ngIf="viewModel.hasValidationError('email')">
                            {{viewModel.getValidationMessage("email")}}
                        </div> -->
                    </div>

                    <div class="form-outline mb-4">
                        <label class="form-label"> Mobile Number </label>
                        <input type="number" [(ngModel)]="viewModel.userDetails.contact" class="form-control"
                            placeholder="Enter a valid email address" />
                        <!-- <div class="error-message" *ngIf="viewModel.hasValidationError('contact')">
                            {{viewModel.getValidationMessage("contact")}}
                        </div> -->
                    </div>

                    <div class="form-outline mb-3">
                        <label class="form-label"> Password </label>
                        <input type="password" [(ngModel)]="viewModel.userDetails.password" class="form-control"
                            placeholder="Enter password" />
                        <!-- <div class="error-message" *ngIf="viewModel.hasValidationError('password')">
                            {{viewModel.getValidationMessage('password')}}
                        </div> -->
                    </div>


                    <div class="form-check mb-0">
                        <input type="checkbox" class="form-check-input me-2" value="" />
                        <label class="form-check-label">
                            I accept Terms & Condition of Security Related
                        </label>
                    </div>

                    <div class="text-center text-lg-center mt-4 pt-2">
                        <button type="button" class="btn signUp" (click)="click_SignUp()"> Sign Up </button>
                    </div>

                </div>

            </div>

        </div>

    </div>
</div>